var monaApp = angular.module('monaApp', [
	'ngCookies',
    'ui.router',
    'mainApp'
]);

monaApp.config([
        '$stateProvider', '$urlRouterProvider', '$httpProvider', '$sceDelegateProvider', '$locationProvider', 
function($stateProvider, $urlRouterProvider, $httpProvider, $sceDelegateProvider, $locationProvider){

    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    
    $.ajaxSetup({
        crossDomain: false,
        beforeSend: function(xhr, settings){
            if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type)){
                xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
            }
        }
    });

    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'http://*.pbs.org/**',
        'http://*.wgbhdigital.org/**',
        'http://localhost**'
    ]);

    var base = "partials/";

    // todo: look at using parent property for simpler reading of nested views: https://github.com/angular-ui/ui-router/wiki/Nested-States-and-Nested-Views

    // todo: look at transitions between states --> $state.transitionTo(states.contacts);

    $stateProvider
        .state('intro', {
            url: '/intro',
            templateUrl: base+'intro.html',
            controller: 'introController as intro'
        })
        .state('video', {
            parent: 'intro',
            url: '/video',
            templateUrl: base+'intro-video.html',
            controller: 'introVideoController as introvid'
        })
        .state('map', {
            url: '/map',
            templateUrl: base+'map.html',
            controller: 'mapController as map'
        })
        .state('home', {
            parent: 'map',
            url: '/home',
            templateUrl: base+'map-home.html',
            controller: 'mapHomeController'
        })        
        .state('expedition', {
            // todo: make this url not reachable
            parent: 'map',
            url: '/expedition',
            templateUrl: base+'map-expedition.html',
            controller: 'mapExpeditionController as expedition'
        })        
        .state('expeditionmenu', {
            parent: 'expedition',
            url: '/menu',
            templateUrl: base+'map-expedition-menu.html',
            controller: 'mapExpeditionMenuController as menu'
        })   
        .state('progress', {
            parent: 'expedition',
            url: '/progress',
            templateUrl: base+'map-expedition-progress.html',
            controller: 'mapExpeditionProgressController as progress'
        })             
        .state('strand', {
            parent: 'expedition',
            url: '/:strand',
            templateUrl: base+'map-expedition-strand.html',
            controller: 'mapExpeditionStrandController as strand'
        })  
        .state('expstop', {
            parent: 'strand',
            url: '/:expstop',
            templateUrl: base+'map-expedition-strand-expstop.html',
            controller: 'mapExpeditionStrandStopController as expstop'
        })      
        .state('explore', {
            parent: 'map',
            url: '/explore',
            templateUrl: base+'map-explore.html',
            controller: 'mapExploreController as explore'
        })         
        .state('location', {
            parent: 'explore',
            url: '/:slug',
            templateUrl: base+'map-explore-location.html',
            controller: 'mapExploreLocationController as location'
        })  
        .state('watchshow', {
            url: '/watchshow',
            templateUrl: base+'watchshow.html',
            controller: 'watchshowController as watchshow'
        })

}]);

monaApp.run([
        '$rootScope', '$http', '$cookies', '$state', '$location',
function($rootScope,   $http,   $cookies,   $state,   $location){
    $http.defaults.headers.post['X-CSRFToken'] = $cookies.csrftoken;
    //window.setTimeout(function(){ $state.go('explore') }, 1);
    //window.setTimeout(function(){ $state.go('location', {slug:'misty-mountain'}) }, 1);
    window.setTimeout(function(){ $state.go('intro') }, 1);

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, $scope){ 
        var to = toState.name,
            from = fromState.name;

        logit("to   state = " + to)

        if (from === '' && to === 'evo.buildatree') { event.preventDefault() }
        if (from === '' && to === 'evo.deeptree') { event.preventDefault() }

// **** uncomment before launch *** todo: I think this is OK now
        // lock-out
        if (!_notlive) {
            if (toParams.strand === '2') { event.preventDefault() } // todo: delete when Trek 2 is available
            if (toParams.strand === '3') { event.preventDefault() } // todo: delete when Trek 3 is available            
        }
// *** end uncomment **** 

    })
    $rootScope.$on('$viewContentLoaded', function(){
      //view loaded do some stuff.
        $location.replace(); //clear last history route
    });
    $rootScope.$on('$stateChangeSuccess', function() {
       document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

}])

var mainApp = angular.module('mainApp', [
    'ui.router',
    'ngSanitize',
    'ngAnimate'
])

// ****  helper functions ********************************************

var _debug = true
var _notlive = location.hostname === "localhost" || location.hostname === "dipsy.pbs.org" || location.hostname === "demo.wgbhdigital.org"

function logit(msg) {
    if(window.console && _debug && _notlive){
        console.log(msg);
    }
}